// Import images
import LegalImg from "../../Assets/img/investment (2) 2.svg";
import TechnologyImg from "../../Assets/img/healthcare (2) 1.svg";
import RecruitmentImg from "../../Assets/img/accounting (2) 2.svg";
import EngineeringImg from "../../Assets/img/worker 2.svg";
import HealthcareImg from "../../Assets/img/engineering_12148700 2.svg";
import FinanceImg from "../../Assets/img/recruitment_2083461 2.svg";
import HospitalityImg from "../../Assets/img/science_2029155 2.svg";
import ManufacturingImg from "../../Assets/img/law_7238364 2.svg";
import AccountingImg from "../../Assets/img/healthcare (3) 2.svg";
import send from "../../Assets/img/send (2) 2.png";
import { Link } from "react-router-dom";
import { useState } from "react";
const ServicesIndustry = () => {
  const [activeId, setActiveId] = useState(null);
  const industries = [
    // { id: "logo-legal", title: "Legal", img: LegalImg },
    { id: "logo-technology", title: "Technology", img: HospitalityImg },
    // { id: "logo-recruitment", title: "Recruitment", img: RecruitmentImg },
    { id: "logo-engineering", title: "Engineering", img: HealthcareImg },
    { id: "logo-healthcare", title: "Healthcare", img: AccountingImg },
    { id: "logo-finance", title: "Finance", img: LegalImg },
    // { id: "logo-hospitality", title: "Hospitality", img: HospitalityImg },
    // { id: "logo-manufacturing", title: "Manufacturing", img: ManufacturingImg },
    { id: "logo-accounting", title: "Accounting", img: RecruitmentImg },
  ];

  return (
    <>
      <section className="services-5 py-5 text-white">
  <h1 className="fs-4 fw-bold text-center mb-5">
    Your Industry, Our Expertise
  </h1>

  <div className="logo-container-service">
    {industries.map((industry) => (
      <div
        key={industry.id}
        className={`industry-item ${activeId === industry.id ? "active" : ""}`}
        onMouseEnter={() => setActiveId(industry.id)}
        onMouseLeave={() => setActiveId(null)}
      >
        {/* Icon wrapper */}
        <div className="icon-box">
          <img src={industry.img} alt={industry.title} className="logo" />
        </div>
        
        {/* Title directly under icon */}
        <span className="industry-title">{industry.title}</span>
      </div>
    ))}
  </div>
</section>
      <section className="banner-content">
        <div className="banner-container">
          <div className="banner-1">
            Start Your Hiring Journey with Our Experts.
          </div>

          <div className="banner-2">
            <span>Start Hiring</span>
            <Link to="/contact-us">
              <img src={send} alt="icon" />
            </Link>
            <span>Start Hiring</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesIndustry;
